
// load locales
import en from './en/translation'
import it from './it/translation'
import es from './es/translation'

export default { en, it, es }
